<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import router from './router';
export default {
  name: 'App',
  router,
  // methods:{
  //   mounted () {
  //   // 关闭浏览器窗口的时候清空浏览器缓存在localStorage的数据
  //     window.addEventListener('beforeunload', e => {
  //       localStorage.clear()
  //     })
  //   }    
  // }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height:100%;
  margin-top: 0;
  background:#ffffff;
}
</style>

